module.exports = __webpack_public_path__ + "static/img/propuestas-3.b8eb385.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/portfolio/propuestas-3.jpg
// module id = 9Hy2
// module chunks = 1